export default __webpack_public_path__ + "static/char-s-16-kr-5e1fdda1d3f5ecd4c65dbc26a2c13174.webp";